import { ImageCtaCardSection, FAQSection, TrimixWhyDefyMedSection } from "@/design-system/Organisms";
import { trimixFaqDataConfig } from "@/design-system/Organisms/FAQSection/faq.config";
import { trimixImageCtaCardConfig } from "@/design-system/Organisms/ImageCtaCardSection/imageCtaCard.config";
import { TrimixBgSwoopTemplate } from "@/design-system/Templates/TrimixBgSwoopTemplate";

export const TrimixTemplate = () => {
  return (
    <>
      <TrimixBgSwoopTemplate />
      <TrimixWhyDefyMedSection />
      <FAQSection {...trimixFaqDataConfig} />
      <ImageCtaCardSection {...trimixImageCtaCardConfig} />
    </>
  );
};

export default TrimixTemplate;
